import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Skeleton } from "@/components/ui/skeleton";
import { BookingCard } from "@/components/BookingCard";
import { isPastDate } from "@/lib/studio";
import { api, apiError } from "@/lib/api";

const List = ({ items, onCancel, empty, testId }) =>
  items.length === 0 ? (
    <div className="surface p-10 text-center" data-testid={`${testId}-empty`}>
      <p className="text-zinc-400">{empty}</p>
      <Link to="/book" className="btn-riot mt-6" data-testid={`${testId}-book-btn`}>Book a session</Link>
    </div>
  ) : (
    <div className="space-y-4" data-testid={testId}>
      {items.map((b) => <BookingCard key={b.id} booking={b} onCancel={onCancel} />)}
    </div>
  );

export default function MyBookings() {
  const [bookings, setBookings] = useState(null);

  useEffect(() => {
    api.get("/bookings/mine").then((r) => setBookings(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  const cancel = async (id) => {
    try {
      const { data } = await api.post(`/bookings/${id}/cancel`);
      setBookings((prev) => prev.map((b) => (b.id === id ? data : b)));
      toast.success("Booking cancelled");
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  const upcoming = (bookings || []).filter((b) => b.status === "confirmed" && !isPastDate(b.date));
  const history = (bookings || []).filter((b) => !upcoming.includes(b)).reverse();

  return (
    <main className="mx-auto max-w-5xl px-6 py-16 md:px-12" data-testid="my-bookings-page">
      <p className="eyebrow rise">Your sessions</p>
      <h1 className="rise d1 mt-4 font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-5xl">My bookings</h1>
      {bookings === null ? (
        <div className="mt-12 space-y-4">{[0, 1].map((i) => <Skeleton key={i} className="h-28 w-full" />)}</div>
      ) : (
        <Tabs defaultValue="upcoming" className="mt-12">
          <TabsList className="mb-8 bg-[#121216]">
            <TabsTrigger value="upcoming" data-testid="tab-upcoming">Upcoming ({upcoming.length})</TabsTrigger>
            <TabsTrigger value="history" data-testid="tab-history">Past & cancelled ({history.length})</TabsTrigger>
          </TabsList>
          <TabsContent value="upcoming">
            <List items={upcoming} onCancel={cancel} empty="No upcoming sessions yet." testId="upcoming-list" />
          </TabsContent>
          <TabsContent value="history">
            <List items={history} onCancel={cancel} empty="Nothing here yet." testId="history-list" />
          </TabsContent>
        </Tabs>
      )}
    </main>
  );
}
